<template>
  <el-collapse-item
    title="Recruiter Progress"
    name="recruiter_progress"
  >
    <p
      v-for="(progress, idx) in recruiterProgress"
      :key="idx"
    >
      <strong>{{ progress.step | removeDashes | ucwords }}:</strong>
      <span :class="[progress.completion ? 'code__success' : 'code__error']">
        <i :class="[progress.completion ? 'el-icon-success' : 'el-icon-error']" />
      </span>
    </p>
  </el-collapse-item>
</template>

<script>
export default {
  name: 'RecruiterProgress',
  props: {
    recruiterProgress: {
      type: Array,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "~vars";

  .code__success {
    color: $-color-success;
  }

  .code__error {
    color: $-color-error;
  }
</style>
